// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"899":"c4e9311a","937":"62f9b414","953":"3289bf94"}[chunkId] + ".chunk.css";
};